import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { initGA } from './utils/ga';
import Analytics from './utils/ga/Analytics';

const root = ReactDOM.createRoot(document.getElementById('root'));
initGA();

root.render(
  <BrowserRouter>
    <React.StrictMode>
      <Analytics />
      <App />
    </React.StrictMode>
  </BrowserRouter>
);
